var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authorizedAccount"},[_c('data-list',{attrs:{"table-style":{name:'mixture'},"data":_vm.data,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }